import { useState } from "react";
import { Link } from "react-router-dom";
import {
  FaInstagram,
  FaFacebookF,
  FaLinkedinIn,
  FaYoutube,
  FaTiktok,
  FaSpotify,
  FaApple,
  FaAmazon,
} from "react-icons/fa";
import { addMusicSubscriber } from "../firebase/firebase-functions";
import "./footer.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      setError("Please enter your email address");
      return;
    }

    setIsLoading(true);
    setError("");

    try {
      const result = await addMusicSubscriber(email);

      if (result.success) {
        setIsSubscribed(true);
        setEmail("");

        // Reset success message after 3 seconds
        setTimeout(() => setIsSubscribed(false), 3000);
      } else {
        setError(result.error || "Something went wrong. Please try again.");
      }
    } catch (err) {
      setError("Something went wrong. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Social Icons - Top Center */}
        <div className="social-section">
          <div className="social-links">
            <a
              href="https://www.instagram.com/anjyyx/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Follow on Instagram"
              className="social-link instagram"
            >
              <FaInstagram />
            </a>
            <a
              href="https://www.tiktok.com/@anjali.daswani"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Follow on TikTok"
              className="social-link tiktok"
            >
              <FaTiktok />
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=100066200794414"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Follow on Facebook"
              className="social-link facebook"
            >
              <FaFacebookF />
            </a>
            <a
              href="http://www.linkedin.com/in/anjali-daswani-735669200"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Connect on LinkedIn"
              className="social-link linkedin"
            >
              <FaLinkedinIn />
            </a>

            <a
              href="https://open.spotify.com/artist/7BXnSLPZGMGarG0QwEUno8"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Listen on Spotify"
              className="social-link spotify"
            >
              <FaSpotify />
            </a>
            <a
              href="https://music.apple.com/us/artist/anjali-daswani/1750771474"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Listen on Apple Music"
              className="social-link apple"
            >
              <FaApple />
            </a>
            <a
              href="https://www.amazon.com/music/player/artists/B0D6F2YZ7H/anjali-daswani"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Listen on Amazon Music"
              className="social-link amazon"
            >
              <FaAmazon />
            </a>
            <a
              href="https://www.youtube.com/watch?v=jQ-Zi4ZqHps&ab_channel=CollegeofPerformingArtsatTheNewSchool&start=526"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Watch on YouTube"
              className="social-link youtube"
            >
              <FaYoutube />
            </a>
          </div>
        </div>

        {/* Content Below Icons */}
        <div className="footer-content">
          {/* Brand Section */}
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              Anjali D Music
            </Link>
            <p className="footer-description">
              Singer • Songwriter • Storyteller
              <br />
              Sharing stories through music from NYC
            </p>
          </div>

          {/* Navigation Links */}
          <div className="footer-nav">
            <h4>Navigate</h4>
            <ul>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/bio">Bio</Link>
              </li>
              <li>
                <Link to="/music">Music</Link>
              </li>
              <li>
                <Link to="/contact">Contact</Link>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div className="footer-newsletter">
            <h4>Stay Updated</h4>
            <p>Get notified of new releases and upcoming shows</p>

            {!isSubscribed ? (
              <form onSubmit={handleSubmit} className="newsletter-form">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  className="newsletter-input"
                  aria-label="Email for newsletter"
                  disabled={isLoading}
                />
                <button
                  type="submit"
                  className="newsletter-btn"
                  disabled={isLoading}
                >
                  {isLoading ? "Subscribing..." : "Subscribe"}
                </button>
                {error && <p className="error-message">{error}</p>}
              </form>
            ) : (
              <div className="success-message">
                <p className="success-text">Thanks for subscribing!</p>
              </div>
            )}
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <p>&copy; {currentYear} Anjali Daswani. All rights reserved.</p>
          <div className="footer-links">
            <Link to="/privacy" className="footer-link">
              Privacy Policy
            </Link>
            <Link to="/terms" className="footer-link">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
